export default "__VITE_ASSET__BYhDi9nY__"